// Horizon opens theme drawers (the cart drawer) as a sidebar on wide screens: it squeezes the page
// to make room and reopens itself after navigation. WILD shows drawers as an overlay instead:
// - the page keeps its width (see "Horizon theme drawers" in wild.css);
// - a scrim dims the page while a drawer is open, and clicking it (or Escape) closes the drawer;
// - an open drawer is not carried over to the next page.
// Narrow screens are untouched: there Horizon already uses a modal dialog with its own backdrop.

const RESTORE_KEY = 'theme-drawer-open';
const OPEN_CLASS = 'page-wrapper--drawer-open';

const wrapper = document.querySelector('.page-wrapper');

if (wrapper) {
  const scrim = document.createElement('div');
  scrim.className = 'wild-drawer-scrim';
  scrim.setAttribute('aria-hidden', 'true');
  document.body.append(scrim);

  const isOpen = () => wrapper.classList.contains(OPEN_CLASS);
  const sync = () => scrim.classList.toggle('is-visible', isOpen());

  const closeDrawers = () => {
    for (const drawer of document.querySelectorAll('theme-drawer')) {
      if (drawer.querySelector('dialog[open]')) drawer.querySelector('.theme-drawer__close-button')?.click();
    }
  };

  new MutationObserver(sync).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
  sync();

  scrim.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen()) closeDrawers();
  });

  addEventListener('pagehide', () => {
    try {
      sessionStorage.removeItem(RESTORE_KEY);
    } catch {
      // Storage can be unavailable (private mode); nothing to clear then.
    }
  });
}
